import { AppContext } from '../../services/context.service';

export type MobileNavItemId = 'dashboard' | 'context' | 'notifications' | 'profile';

export interface MobileNavItem {
  id: MobileNavItemId;
  route: string;
  labelKey: string;
  icon: string;
  matchPrefixes: string[];
}

interface ContextNavConfig {
  route: string;
  labelKey: string;
  matchPrefixes: string[];
}

export const CONTEXT_NAV_CONFIG: Record<AppContext, ContextNavConfig> = {
  admin: {
    route: '/admin/assignments',
    labelKey: 'pages.dashboard.context.admin',
    matchPrefixes: ['/admin']
  },
  coach: {
    route: '/coach/athletes',
    labelKey: 'pages.dashboard.context.coach',
    matchPrefixes: ['/coach']
  },
  parent: {
    route: '/parent/children',
    labelKey: 'pages.dashboard.context.parent',
    matchPrefixes: ['/parent']
  },
  player: {
    route: '/player/coaches',
    labelKey: 'pages.dashboard.context.player',
    matchPrefixes: ['/player']
  }
};

const STATIC_NAV_ITEMS: Array<Omit<MobileNavItem, 'id'> & { id: Exclude<MobileNavItemId, 'context'> }> = [
  {
    id: 'dashboard',
    route: '/dashboard',
    labelKey: 'pages.mobile_shell.bottom_nav.dashboard',
    icon: '⌂',
    matchPrefixes: ['/dashboard']
  },
  {
    id: 'notifications',
    route: '/notifications',
    labelKey: 'pages.mobile_shell.bottom_nav.notifications',
    icon: '🔔',
    matchPrefixes: ['/notifications']
  },
  {
    id: 'profile',
    route: '/profile',
    labelKey: 'pages.mobile_shell.bottom_nav.profile',
    icon: '◉',
    matchPrefixes: ['/profile']
  }
];

export function buildMobileNavItems(context: AppContext): MobileNavItem[] {
  const contextItem: MobileNavItem = {
    id: 'context',
    route: CONTEXT_NAV_CONFIG[context].route,
    labelKey: CONTEXT_NAV_CONFIG[context].labelKey,
    icon: '▦',
    matchPrefixes: CONTEXT_NAV_CONFIG[context].matchPrefixes
  };

  return [STATIC_NAV_ITEMS[0], contextItem, STATIC_NAV_ITEMS[1], STATIC_NAV_ITEMS[2]];
}
